import {
  CreatePrintingTechniqueState,
  CreatePrintingTechniqueType, CreatePrintingTechniqueTypes,
} from "./data";
import { CreateArtworkCollectionState } from "../../collection/create/data";

const initialState: CreatePrintingTechniqueState = {
  id: "",
  code: "",
  collection: {} as CreateArtworkCollectionState,
  image: "",
  name: "",
  isReadOnly: false,
  color: null,
  technical_file_comment: "",
  decoration_technique: null,
  molds: null,
  purchased_parts: "N",
  submit_comment:"",
  history: [],
  status:null,
  isValid:false,
};

const reducer = (
  state: CreatePrintingTechniqueState,
  action: CreatePrintingTechniqueType,
) => {
  if (action.type === CreatePrintingTechniqueTypes.SET_PRINTING_TECHNIQUE) {
    return { ...state, ...action.payload };
  }

  return { ...state, [action.type]: action.payload };
};

export const CreatePrintingTechniqueReducer = { initialState, reducer };
